import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // Initialize with null or empty array
  private dataSubject = new BehaviorSubject<any>(null);
  
  // Expose as observable
  public data$: Observable<any> = this.dataSubject.asObservable();

  constructor() { }

  setData(value: any) {
    this.dataSubject.next(value);
  }

  getData(): Observable<any> {
    return this.data$;
  }
}